module.exports = "<div class=\"gw-wizard-sidebar-steps\">\n    <div class=\"gw-section-title\">\n        <span>{{title}}</span>\n    </div>\n    <ul class=\"gw-steps\">\n        <li ng-repeat=\"step in wizardSteps\" ng-class=\"step.styleClass\"\n            ng-click=\"selectStep(step.name)\"\n            ng-show=\"getVisibleStatus(step.name)\">{{ stepLabel(step) }}\n        </li>\n    </ul>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/wizard/templates/wizard-sidebar-ribbon.html
 ** module id = 732
 ** module chunks = 0
 **/